import imgCarousel1 from "../../assets/images/carousel-1.jpg";
import imgCarousel2 from "../../assets/images/carousel-2.jpg";
import imgCarousel3 from "../../assets/images/carousel-3.jpg";
import imgCarousel4 from "../../assets/images/carousel-4.jpg";

const fixture = {
  images: [imgCarousel1, imgCarousel2, imgCarousel3, imgCarousel4],
  width: 300,
  height: 460,
};

export default fixture;
